var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolanaWordmark = function SvgSolanaWordmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 10,
    viewBox: "0 0 65 10",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19357_18029",
    width: 65,
    height: 10,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.155 0h64.573v9.596H.155V0Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19357_18029)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_19357_18029)",
    d: "m11.002 7.566-1.772 1.9a.41.41 0 0 1-.3.13H.534a.206.206 0 0 1-.151-.346l1.77-1.899a.41.41 0 0 1 .3-.131h8.396a.205.205 0 0 1 .153.346ZM9.23 3.74a.414.414 0 0 0-.3-.13H.534a.206.206 0 0 0-.151.345l1.77 1.9a.414.414 0 0 0 .3.132h8.396a.206.206 0 0 0 .15-.346L9.23 3.74ZM.534 2.376H8.93a.41.41 0 0 0 .3-.13l1.772-1.9A.205.205 0 0 0 10.849 0H2.452a.41.41 0 0 0-.3.131l-1.769 1.9a.206.206 0 0 0 .15.345Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.239 4.058h-4.493V2.58h5.66V1.1h-5.674a1.477 1.477 0 0 0-1.485 1.47v1.498a1.474 1.474 0 0 0 1.485 1.47h4.498v1.48h-5.876v1.48h5.885a1.476 1.476 0 0 0 1.484-1.469v-1.5a1.476 1.476 0 0 0-1.484-1.47ZM29.94 1.1h-4.51a1.476 1.476 0 0 0-1.488 1.468v4.46a1.474 1.474 0 0 0 1.489 1.469h4.509a1.477 1.477 0 0 0 1.484-1.469v-4.46A1.475 1.475 0 0 0 29.941 1.1Zm-.011 5.917h-4.487V2.58h4.485l.002 4.438ZM45.734 1.1h-4.398a1.476 1.476 0 0 0-1.484 1.468v5.929h1.5v-2.43h4.377v2.43h1.5V2.568A1.476 1.476 0 0 0 45.734 1.1Zm-.01 3.487h-4.379V2.58h4.378v2.008ZM63.241 1.1h-4.398a1.476 1.476 0 0 0-1.485 1.468v5.929h1.5v-2.43h4.368v2.43h1.5V2.568A1.477 1.477 0 0 0 63.241 1.1Zm-.015 3.487H58.85V2.58h4.378v2.008Zm-8.696 2.43h-.6L51.787 1.72a.987.987 0 0 0-.916-.62h-1.33a.984.984 0 0 0-.99.98v6.418h1.5V2.579h.6l2.142 5.298a.991.991 0 0 0 .92.616h1.33a.984.984 0 0 0 .99-.98V1.1h-1.502v5.917ZM34.249 1.1h-1.5v5.928a1.477 1.477 0 0 0 1.49 1.469h4.498v-1.48H34.25V1.1Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19357_18029",
    x1: 1.234,
    x2: 10.038,
    y1: 9.825,
    y2: -0.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9945FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8752F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5497D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#43B4CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#28E0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#19FB9B"
  })))));
};
export default SvgSolanaWordmark;